import type { BreadcrumbItem, BreadcrumbVisibility } from '~/@types/cms';
import type { PageProps, ProductPageProps } from '~/@types/generic';
import { useSeo } from '~/composables/seo';

/**
 * ## Page Composable
 * Your one stop shop for all page relate things
 * - breadcrumbs
 * - page data
 * - reference helper
 * - SEO
 * - ...
 */
export const usePage = (props: PageProps | ProductPageProps) => {
    useSeo(props);
    const localePath = useLocalePathWoom();

    const page = computed(() => props.pageData?.page);

    const breadcrumbItems = computed(
        () =>
            (page.value?.breadcrumbs?.reduce((accumulator, currentValue) => {
                if (currentValue.breadcrumb && currentValue.url?.url) {
                    accumulator.push({
                        title: currentValue.breadcrumb,
                        slug: localePath(currentValue.url.url),
                    } as BreadcrumbItem);
                }
                return accumulator;
            }, []) ?? []) as BreadcrumbItem[],
    );

    const breadcrumbVisibility: BreadcrumbVisibility = (page.value?.breadcrumbVisibility as BreadcrumbVisibility) ?? 'none';

    return {
        breadcrumbItems,
        breadcrumbVisibility,
        page,
        pageId: computed(() => props.pageData?.id),
        isBike: computed(() => isProductBike(page.value?.product)),
    };
};
